import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import EventEmitter, {
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../utils/authorization'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { HighlightInformation } from '../../../common/header/highlightInformation'
import {
  itemHighlightBank,
  itemHighlightCorporate,
  itemHighlightLifeInsurance,
  itemHighlightNonBank,
  itemHighlightNonLifeInsurance,
  itemHighlightSecurity,
} from '../helper/highlightHelpers'
import { keyLoading, selectHighlight, selectLoading } from '../store/slice'
import ItemHighlight from './ItemHighlight'

export const FORMAT_TYPES = {
  DECIMAL: 'decimal',
  CURRENCY_EXCHANGE: 'currencyExchange',
  PERCENTAGE: 'percentage',
}

const getDetailItemHighlight = (ratioCode, companyType) => {
  if (companyType === COMPANY_TYPES.CORPORATE) {
    return itemHighlightCorporate(ratioCode)
  } else if (companyType === COMPANY_TYPES.BANK) {
    return itemHighlightBank(ratioCode)
  } else if (companyType === COMPANY_TYPES.NON_BANK) {
    return itemHighlightNonBank(ratioCode)
  } else if (companyType === COMPANY_TYPES.LIFE_INSURANCE) {
    return itemHighlightLifeInsurance(ratioCode)
  } else if (companyType === COMPANY_TYPES.NON_LIFE_INSURANCE) {
    return itemHighlightNonLifeInsurance(ratioCode)
  } else {
    return itemHighlightSecurity(ratioCode)
  }
}

const Highlight = ({ setIsShowPreferenceSetting }) => {
  const { fiscalYearEnd, companyType } = useSelector(selectCompanyInfo)
  const loading = useSelector(selectLoading(keyLoading.HIGHLIGHT))
  const highlight = useSelector(selectHighlight)
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const year = new Date(fiscalYearEnd).getFullYear()
  const data = highlight[year] || []

  const goToPreferenceSetting = () => {
    if (isDisable) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    } else {
      setIsShowPreferenceSetting(true)
    }
  }

  const isDisable =
    AUTHORIZATION_API.companyAnalysis.preferenceSettings[
      userType.userTypeId
    ] === AUTHORIZATION_TYPE.DISABLE

  return (
    <HighlightInformation
      isLoading={loading}
      isWarningWhenNotHasPanel
      goToSettingPanel={goToPreferenceSetting}
      highlights={data.map((item) => {
        const detail = getDetailItemHighlight(item.id, companyType)

        return {
          title: item.ratioName,
          detail: (
            <ItemHighlight
              value={item.value}
              unit={item.unit}
              {...detail.props}
            />
          ),
          scrollElementClass: detail.scrollElementClass,
        }
      })}
    />
  )
}

Highlight.propTypes = {
  setIsShowPreferenceSetting: PropTypes.func.isRequired,
}

export default Highlight
